import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { GUTTER_LINE_CONFIG } from '../constant';
import useRoofLines from '../useRoofLines';
import { ModalBox, ModalBoxWrap } from 'components/tool/Editor/ButtonDiv/Facet/EdgeTool/style';
import { LegendUL } from './style';
import { selectAllEdges , selectFilteredGutterLines } from 'store/slices/RoofDataSlice/roofSelector';

export function SpecialEdgesColorLegend(){
	const roofLines = useRoofLines();

	const { fullScreenEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
	const allRoofEdges = useSelector(selectAllEdges);
	const { showAutoDetectedEdges } = useSelector((state: RootState) => state.roofData.data);

	const specialEdgesTypeList = useMemo(()=>{
		const localSpecialEdges = new Set<string>();
		for(const edge of allRoofEdges){
			if(!edge.specialEdge?.type) continue;
			if(!showAutoDetectedEdges && edge.specialEdge.isSystemDetected) continue;
			localSpecialEdges.add(edge.specialEdge.type);
		}
		return Array.from(localSpecialEdges);
	},[allRoofEdges, showAutoDetectedEdges]);

	const gutterLinesExists = !!useSelector(selectFilteredGutterLines).length;

	return(
		<ModalBoxWrap className={`${ fullScreenEnabled ? 'fullscreen ': ''}`}>
			<ModalBox style={{paddingInline: 0}}>
				<LegendUL>
					{specialEdgesTypeList.map((edgeType, index) => {
						const edgeTypeInfo = roofLines[edgeType];
						return(
							<li className="gutter-line-li"
								key={index}
							>
								<span style={{ backgroundColor: `${edgeTypeInfo.color}`}}></span>
								<label>{edgeTypeInfo.name}</label>	
							</li>
						);
					})}
					{ gutterLinesExists && 
						<li className="gutter-line-li line-exists">
							<span style={{ backgroundColor: GUTTER_LINE_CONFIG.color}}></span>
							Gutters
						</li>
					}
				</LegendUL>
			</ModalBox>
		</ModalBoxWrap>
	);
}